// extracted by mini-css-extract-plugin
export default {"tabsContainer":"TabsComponent_tabsContainer__MKGWS","tab":"TabsComponent_tab__HcgXa","Bigtab":"TabsComponent_Bigtab__D7A1F","smalltab":"TabsComponent_smalltab__rNXob"};